export async function getCsrfToken() {
  const res = await fetch(`${import.meta.env.VITE_API}auth/csrf-token`, {
    credentials: 'include',
  });
  const data = await res.json();
  return data.csrfToken;
}
